import { fullWidth } from "../../blocks/layout/columnSpans";
import { PageDefinition } from "../pageDefinition.types";
import { HelpDocumentPanel } from "./HelpDocumentPanel";

/** The portal's guides: the overview of them, or the one picked. */
export const helpPageDefinition: PageDefinition = {
  path: "/help",
  title: "Help",
  rows: [
    {
      id: "row-help",
      panels: [
        {
          id: "panel-document",
          title: "",
          span: fullWidth,
          component: HelpDocumentPanel,
          plain: true,
        },
      ],
    },
  ],
};
